import { IOtaStep, getActiveOta } from '../api/getActiveOta';
import { OTA_EXECUTION_STATUS, OTA_STEP_NAME, OTA_STEP_STATUS } from '../types';

interface IBoxOtaActiveProgressView {
  isInProgress: boolean;
  steps: IOtaStep[];
  firstPendingIndex: number;
  executionStartedAt: string | undefined;
}

export const useBoxOtaActiveProgressView = (
  lpUI: string
): IBoxOtaActiveProgressView => {
  const { data } = getActiveOta({ lpUI });

  if (data?.execution?.status !== OTA_EXECUTION_STATUS.IN_PROGRESS) {
    return {
      isInProgress: false,
      steps: [],
      firstPendingIndex: -1,
      executionStartedAt: undefined,
    };
  }

  const steps = data.execution.steps.filter(
    (s) => s.step !== OTA_STEP_NAME.END
  );
  const { hasExplicitInProgress, firstPendingIndex } = steps.reduce(
    (acc, s, index) => ({
      hasExplicitInProgress:
        acc.hasExplicitInProgress || s.status === OTA_STEP_STATUS.IN_PROGRESS,
      firstPendingIndex:
        acc.firstPendingIndex === -1 && s.status === OTA_STEP_STATUS.PENDING
          ? index
          : acc.firstPendingIndex,
    }),
    { hasExplicitInProgress: false, firstPendingIndex: -1 }
  );
  const executionStartedAt = steps[0]?.started_at;

  return {
    isInProgress: true,
    steps,
    firstPendingIndex: hasExplicitInProgress ? -1 : firstPendingIndex,
    executionStartedAt,
  };
};
